import { useAtomValue } from 'jotai';
import { clientConfigFieldsAtom } from '../services/state/AppConfigStateJ';

export function useShowAumniData(): boolean {
  const clientConfig = useAtomValue(clientConfigFieldsAtom);
  return clientConfig?.Show_Aumni_Data !== false;
}
